/* PoC: one active viewer per project across tabs. Off by default.
 * `?exoPocSingleViewer=1` turns it on for this browser profile (stored in
 * localStorage, so new tabs pick it up), `?exoPocSingleViewer=0` turns it off.
 * Kept free of imports: `src/index.ts` loads this in the entry chunk through
 * `./boot`. */
export const OPT_IN_PARAM = 'exoPocSingleViewer';
export const OPT_IN_STORAGE_KEY = OPT_IN_PARAM;
export const PARKED_PARAM = 'exoPocViewerParked';
// Set by the parked page's "Use here" so the reloaded tab takes the viewer.
export const CLAIM_STORAGE_KEY = 'exoPocSingleViewerClaim';

export type SingleActiveViewerMode = 'off' | 'on' | 'parked';

export const getSingleActiveViewerMode = (): SingleActiveViewerMode => {
  try {
    const params = new URLSearchParams(window.location.search);
    const optIn = params.get(OPT_IN_PARAM);

    if (optIn === '1') localStorage.setItem(OPT_IN_STORAGE_KEY, '1');
    if (optIn === '0') localStorage.removeItem(OPT_IN_STORAGE_KEY);
    if (localStorage.getItem(OPT_IN_STORAGE_KEY) !== '1') return 'off';

    return params.has(PARKED_PARAM) ? 'parked' : 'on';
  } catch {
    // Storage blocked: stay on the default path.
    return 'off';
  }
};

export const getViewerUrl = (href: string): string => {
  const url = new URL(href);
  url.searchParams.delete(PARKED_PARAM);
  return url.toString();
};
